"use strict";

exports.__esModule = true;
exports.extractWixMediaId = extractWixMediaId;
function extractWixMediaId(src) {
  if (src) {
    const regex = /static\.wixstatic\.com\/media\/([\w\d~\.\%]*)/;
    const match = src.match(regex);
    return match && match[1];
  }
  return null;
}
//# sourceMappingURL=utils.js.map